import { useEffect, useState } from "react";

/** Tailwind `md` breakpoint (matches `md:` utilities). */
const MD_BREAKPOINT = 768;

/**
 * Viewport-based mobile check using `matchMedia`. Reactive to resize and
 * orientation change.
 *
 * Use when a component needs to swap between two entirely different DOM trees
 * based on viewport width (e.g. Drawer vs Dialog) — Tailwind responsive
 * classes can't do that. For purely visual responsive treatment, prefer
 * `md:`/`lg:` utilities.
 */
export function useIsMobileViewport(breakpoint = MD_BREAKPOINT): boolean {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
    });

    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const handler = (e: MediaQueryListEvent): void => setIsMobile(e.matches);
        mql.addEventListener("change", handler);
        setIsMobile(mql.matches);
        return (): void => mql.removeEventListener("change", handler);
    }, [breakpoint]);

    return isMobile;
}
